"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AuthStore = require("crm_data/store/AuthStore");

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var IsUngatedStore = (0, _AuthStore.defineAuthStore)({
  getter: function getter(state, gate) {
    return gate && state.includes(gate);
  },
  initialState: [],
  name: 'IsUngatedStore',
  onAuthLoad: function onAuthLoad(auth) {
    return auth.gates;
  }
}).register(_dispatcher.default);
var _default = IsUngatedStore;
exports.default = _default;
module.exports = exports.default;